<template>
  <div class="row">
    <div class="col-6">
      <q-btn class="btn btn-outline-primary q-mr-lg"
             @click="onSendDocumentClick"
             :label="$t('task.buttons.send_document')"
             :disable="!selectedTemplates.length"
             >
      </q-btn>
    </div>
    <div class="col-6">
      <q-btn class="btn btn-primary q-mr-lg"
             @click="onDownloadDocumentClick"
             :label="$t('task.buttons.download_document')"
             :disable="!selectedTemplates.length"
             :loading="isDownloadDocumentLoading">
        <template v-slot:loading>
          <q-spinner-facebook />
        </template>
      </q-btn>
    </div>
  </div>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";
import store from "@/store";
import { PDFDocument } from "pdf-lib";

@Options({
  props: ["reference"],
})
export default class PrintDocumentActions extends Vue {
  reference: any;
  isDownloadDocumentLoading = false
  isSendDocumentLoading = false


  get selectedTemplates() {
    return (store.state.printDocumentModule.templates || [] ).filter((item) => item.selected)
  }

  get templates() {
    return store.state.printDocumentModule.templates
  }

  onDownloadDocumentClick() {
    this.isDownloadDocumentLoading = true
    this.isSendDocumentLoading = false
    store.dispatch('printDocumentModule/generateDocument', {
      currentRoute: this.currentRoute,
      templatesSelected: this.selectedTemplates,
      from:"PrintDocumentActions",
      callback :(templateName: any)=> this.downloadFile(templateName)
    })
  }

  downloadFile(templateName: any){
    store.dispatch("printDocumentModule/downloadFile", {
      request: {
        resourceUid: this.fileId
      },
       callback: (response: any) => this.downloadDocumentResponse(response,templateName),
    });
  }

  countTemplates:any=0
  templatesNames:any=[]
  downloadDocumentResponses:any=[]

  async downloadDocumentResponse(response: any, templateName: any) {
    const selectedTemplate = this.selectedTemplates?.find(
            (item: any) => item.resourceUid === templateName
        );
    const fileName = selectedTemplate?.fileName || response?.originalFileName; 
    this.countTemplates++;
    this.downloadDocumentResponses.push(response);
    this.templatesNames.push(templateName);
    if (this.selectedTemplates.length === this.countTemplates && this.downloadDocumentResponses.length === this.selectedTemplates.length && this.templatesNames.length === this.selectedTemplates.length) {
        await this.mergeAndDownloadPDFs(fileName);
        this.countTemplates = 0;
        this.templatesNames = [];
        this.downloadDocumentResponses = [];
    }
  }

  async mergeAndDownloadPDFs(fileName: any) {
      const mergedPdf = await PDFDocument.create();
      for (const response of this.downloadDocumentResponses) {
          const { content } = response;
          const pdfBytes = Uint8Array.from(atob(content), (char) => char.charCodeAt(0));
          const pdf = await PDFDocument.load(pdfBytes, { ignoreEncryption: true });
          const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
          copiedPages.forEach((page) => mergedPdf.addPage(page));
      }
      const mergedPdfBytes = await mergedPdf.save();
      const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = this.downloadDocumentResponses.length > 1 ? `Editique_${this.reference}.pdf` : `${fileName}_${this.reference}.pdf`;
      downloadLink.click();
      this.viewDocumentResponse()
  }

  get fileId() {
    return store.state.printDocumentModule.fileDetailFileId
  }

  viewDocumentResponse() {
    this.isDownloadDocumentLoading = false
    this.isSendDocumentLoading = false
  }

  async onSendDocumentClick() {

    this.isSendDocumentLoading = true
    await store.dispatch("printDocumentModule/sendTemplate", {
      template: this.selectedTemplates,
    }).then(() => {
      this.isSendDocumentLoading = true
    });
  }

  get currentRoute() {
    return this.$router.currentRoute.value.name;
  }

}
</script>

<style scoped>

</style>
